import { Component, inject, OnInit } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import {
  MatDialogTitle,
  MatDialogContent,
  MatDialogActions,
  MAT_DIALOG_DATA,
  MatDialogRef,
} from '@angular/material/dialog';
import { InputField } from '../../../../shared/components/input-field/input-field';
import { DialogData } from '../../../../shared/models/dialog-data.model';
import { AuthService } from '../../../../core/services/auth.service';

@Component({
  selector: 'app-logs-dialog',
  imports: [
    ReactiveFormsModule,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatButtonModule,
    InputField,
  ],
  templateUrl: './logs-dialog.component.html',
  styleUrl: './logs-dialog.component.scss',
})
export class LogsDialogComponent implements OnInit {
  readonly dialogRef = inject(MatDialogRef<LogsDialogComponent>);

  readonly data = inject<DialogData & { websiteId: number }>(MAT_DIALOG_DATA);

  private fb = inject(FormBuilder);

  private authService = inject(AuthService);

  form = this.fb.nonNullable.group({
    websiteId: [0, [Validators.required]],
    type: ['', Validators.required],
    lines: ['', Validators.required],
    userId: ['', Validators.required],
  });

  logTypes = [
    { label: 'Access', value: 'access' },
    { label: 'Error', value: 'error' },
  ];

  logLines = [
    { label: '10', value: '10' },
    { label: '20', value: '20' },
    { label: '50', value: '50' },
  ];

  ngOnInit(): void {
    this.form.controls.websiteId.setValue(this.data.websiteId);
    this.form.controls.userId.setValue(this.authService.getUser()!.id);
  }

  submit(): void {
    if (this.form.invalid) return;
    this.dialogRef.close(this.form.getRawValue());
  }

  close(): void {
    this.dialogRef.close();
  }
}
